import { ChangeDetectionStrategy, Component, HostBinding, InputSignal, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ebeihilfe-simple-progress',
  templateUrl: './simple-progress.component.html',
  styleUrls: ['./simple-progress.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleProgressComponent {
  public progress: InputSignal<number> = input<number>(0);
  public block: InputSignal<boolean> = input<boolean>(false);
  public wrapperClass: InputSignal<string> = input<string>('');

  @HostBinding('class.antrag-size-progress--block') public get isBlock(): boolean {
    return this.block();
  }
}
